import { createStore } from "vuex";

export default createStore({
  state: {
    userData: {
      name: "",
      username: "",
    },
  },
  getters: {
    getUserData: (state) => state.userData,
  },
  mutations: {
    SET_USER_DATA(state, payload) {
      state.userData = payload;
    },
    CLEAR_USER_DATA(state) {
      state.userData = { name: "", username: "" };
    },
  },
  actions: {},
  modules: {},
});
